import styled from 'styled-components';
import { PH } from './theme';

export const StyledSettingsTab = styled.div`
  font-size: ${PH.fontSizeBase};
  line-height: ${PH.lineHeightBody};
  color: ${PH.text};

  .poshub-settings-card.ant-card {
    border: 1px solid ${PH.border};
    border-radius: 4px;
    box-shadow: none;

    .ant-card-head {
      border-bottom-color: ${PH.border};
      min-height: 56px;
      padding: 0 20px;
    }

    .ant-card-head-title {
      font-size: ${PH.fontSizeTitle};
      font-weight: 700;
      line-height: 26px;
      color: ${PH.text};
      padding: 16px 0;
    }

    .ant-card-body {
      padding: 20px;
    }
  }

  .poshub-settings-grid-header {
    display: grid;
    grid-template-columns: 44px 100px 140px 140px 48px;
    gap: 12px 16px;
    align-items: center;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: ${PH.fontSizeSm};
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${PH.textLabel};
  }

  .poshub-settings-day-label {
    font-weight: 600;
    font-size: ${PH.fontSizeBase};
    color: ${PH.text};
    text-transform: uppercase;
  }
`;
